import { useTranslation } from 'react-i18next';
import { useUsers } from '@connect-x-app/hybrid-state';
import { Text } from '@connect-x-app/hybrid-ui';
import { ConnectivityStatus, FlightRoomUser, FlightRoomUserStatus } from '@connect-x-app/shared-domain-models';
import { COLORS } from '@connect-x-app/shared-ui';
import { getCustomCrewTitle, getIconForUser, UserUtil } from '@connect-x-app/shared-utils';
import { ProfileHeader, ProfileSection, StatusDot } from '@connect-x-app/web-ui';

import '@connect-x-app/web-ui-styles-shared/profile.scss';

export const CrewProfile = ({ crewMember }: { crewMember: FlightRoomUser }) => {
  const { t } = useTranslation();
  const { getUserByExternalId } = useUsers();

  const user = getUserByExternalId(crewMember.externalId);
  const jobTitle =
    getCustomCrewTitle(crewMember.jobTitle, crewMember.jobTitleCustom) ??
    (crewMember.status === FlightRoomUserStatus.SCHEDULED
      ? UserUtil.getDivision(crewMember.jobTitle)
      : UserUtil.getDivision(crewMember.jobTitle ?? user?.jobTitle));

  const icon = getIconForUser({ crewMember, user });

  return (
    <aside className="profile-container">
      {user ? (
        <>
          <ProfileHeader firstName={user.firstName} iconName={icon} jobTitle={jobTitle} lastName={user.lastName} />
          <div className="profile-mid-bot-container">
            <section className="profile-section-mid-container">
              <div className="profile-section-mid-list-item">
                <div className="status-container">
                  <div>
                    <Text color={COLORS.romeo.$07} size="SM" weight="bold">
                      {t('PROFILE.STATUS')}
                    </Text>
                    <Text size="SM">
                      {user.connectivityStatus === ConnectivityStatus.ONLINE
                        ? t('PROFILE.CONNECTION_STATUS.ONLINE')
                        : t('PROFILE.CONNECTION_STATUS.OFFLINE')}
                    </Text>
                  </div>
                  <StatusDot size="medium" status={user?.connectivityStatus} userId={user?.externalId} />
                </div>
              </div>
              <ProfileSection icon="briefcase" title={t('PROFILE.JOB_TITLE')} value={user?.rank} />
              <ProfileSection icon="phone" title={t('PROFILE.PHONE_NUMBER')} value={user?.phoneNumber} />
              <ProfileSection icon="email" title={t('PROFILE.EMAIL')} value={user?.email} />
            </section>
          </div>
        </>
      ) : null}
    </aside>
  );
};
